import { AppThunk } from "store";
import { batch } from "react-redux";

import { getResponseError } from "common/utils";
import dataSources from "dataSources";
import { navigationActions } from "../reducer";
import { applicationActions } from "entities/application";

import { LOADING_STATUS } from "shared/constants";

import { GetTransaction } from "../../types";

export const getClientFuelEventsHistory = (form: GetTransaction): AppThunk => async (dispatch) => {
  const {
    setClientFuelEventsData,
    setClientFuelEventLoadingStatus
  } = navigationActions;
  const { setErrorNotice } = applicationActions;

    try {
      dispatch(setClientFuelEventLoadingStatus(LOADING_STATUS.load));

      const transactionHistory = await dataSources.common.getTransactions(form);

      batch(() => {
        dispatch(setClientFuelEventsData(transactionHistory));
        dispatch(setClientFuelEventLoadingStatus(LOADING_STATUS.done));
      });
    } catch (e) {
      const error = await getResponseError(e);
      batch(() => {
        dispatch(setErrorNotice(error));
        dispatch(setClientFuelEventLoadingStatus(LOADING_STATUS.done));
      });
    }
  };

export const getClientTollsEventsHistory =
  (form: GetTransaction): AppThunk =>
  async (dispatch) => {
    const {
      setClientRoadEventsData,
      setClientRoadEventLoadingStatus
    } = navigationActions;
    const { setErrorNotice } = applicationActions;

    try {
      dispatch(setClientRoadEventLoadingStatus(LOADING_STATUS.load));

      const transactionHistory = await dataSources.common.getTransactions(form);

      batch(() => {
        dispatch(setClientRoadEventsData(transactionHistory));
        dispatch(setClientRoadEventLoadingStatus(LOADING_STATUS.done));
      });
    } catch (e) {
      const error = await getResponseError(e);
      batch(() => {
        dispatch(setErrorNotice(error));
        dispatch(setClientRoadEventLoadingStatus(LOADING_STATUS.done));
      });
    }
  };

export const getClientParkingEventsHistory = (form: GetTransaction): AppThunk => async (dispatch) => {
    const {
      setClientServiceEventData,
      setClientServiceEventLoadingStatus,
    } = navigationActions;
    const { setErrorNotice } = applicationActions;
    
    try {
      dispatch(setClientServiceEventLoadingStatus(LOADING_STATUS.load));

      const transactionHistory = await dataSources.common.getTransactions(form);

      batch(() => {
        dispatch(setClientServiceEventData(transactionHistory));
        dispatch(setClientServiceEventLoadingStatus(LOADING_STATUS.done));
      });
    } catch (e) {
      const error = await getResponseError(e);
      batch(() => {
        dispatch(setErrorNotice(error));
        dispatch(setClientServiceEventLoadingStatus(LOADING_STATUS.done));
      });
    }
  };
